import { Table } from "reactstrap";
import { dynamicImage } from "../../../../../utils";
import { Image } from "../../../../../coreComponents/Image";
import SvgIcon from "../../../../../coreComponents/SvgIcon";

// This component renders the header section of an invoice, including the logo and contact information.
const InvoiceHead = () => {
  return (
    <tr>
      <td>
        <Table  className="table-wrapper" >
          <tbody>
            <tr className="table-header" >
              <td className="p-0 logo-container border-0">
              <Image className="img-fluid for-light" src={dynamicImage(`logo/logo.png`)} alt="looginpage" />
              <Image className="img-fluid for-dark" src={dynamicImage(`logo/logo_dark.png`)} alt="looginpage" />
              </td> 
              <td className="p-0 border-0">
                <ul className="contact-info" >
                  <li>
                    <SvgIcon className="stroke-icon" iconId="call"  />
                    <span className="contact-text"  >(239) 555-0108</span>
                  </li>
                  <li className="separator" >
                    <SvgIcon iconId="email-box"  />
                    <span className="contact-text" >zono@themesforest.com</span>
                  </li>
                  <li>
                    <SvgIcon iconId="web"  />
                    <span  >Website: www.zonothemes.com</span>
                  </li>
                </ul>
              </td>
            </tr>
            <tr className="invoice-wrapper" >
              <td className="p-0 invoice-details">
                <span className="invoice-title" >Invoice to :</span>
                <span className="client-name" >Brooklyn Simmons</span>
                <span className="client-info" >2972 Westheimer Rd. Santa Ana, Illinois 85486 </span>
                <span className="client-info" >Phone : (219) 555-0114</span>
                <span className="client-info" >Email : yourmail@themesforest.com</span>
                <span className="client-info" >Website: www.websites.com</span>
              </td>
              <td className="p-0 invoice-header">
                <h4 className="payment-method" >INVOICE</h4>
                <span className="bank-info" >Bank Transfer</span>
                <span className="bank-info" >Leslie Alexander</span>
                <span className="bank-details">Bank Account : 0981234098765</span>
                <span className="bank-details">Code : LEF098756</span>
              </td>
            </tr>
          </tbody>
        </Table>
      </td>
    </tr>
  );
};

export default InvoiceHead;
